'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { trackEvent } from '@/app/lib/posthog';
import type { AnalyticsEventName, AnalyticsEventProperties } from '@/app/lib/posthog';

export function GuideViewTracker({ guideSlug, audienceCount }: { guideSlug: string; audienceCount: number }) {
  useEffect(() => {
    trackEvent('content:guide_viewed', { guide_slug: guideSlug, audience_count: audienceCount });
  }, [audienceCount, guideSlug]);
  return null;
}

export function GuideLink<N extends AnalyticsEventName>({ href, eventName, eventProperties, className, children }: {
  href: string;
  eventName: N;
  eventProperties: AnalyticsEventProperties<N>;
  className: string;
  children: React.ReactNode;
}) {
  return <Link href={href} onClick={() => trackEvent(eventName, eventProperties)} className={className}>{children}</Link>;
}

export function GuideSourceLink({ href, guideSlug, sourceName, className, children }: {
  href: string;
  guideSlug: string;
  sourceName: string;
  className: string;
  children: React.ReactNode;
}) {
  return <a href={href} target="_blank" rel="noreferrer" onClick={() => trackEvent('content:official_source_clicked', { guide_slug: guideSlug, source_name: sourceName })} className={className}>{children}</a>;
}
